export enum CMDTYPES {
  UI_INFO_API = 1020, // UI 정보 API
  TERMS_LIST_API = 1021, // 약관 목록 API
  OTP_REQUEST_API = 1022, // OTP 요청 API
  OTP_VERIFY_API = 1023, // OTP 검증 API
  SKT_BILL_LETTER_OTP_VERIFY_API = 1024, // SKT BILLLETTER OTP 검증 API
  SKT_BILL_LETTER_JOIN_API = 1025, // SKT BILLLETTER 가입 API
  JOIN_POSSIBLE_CHECK_BY_PCODE = 1026,
  RECAPTCHA_REQUEST_API = 1027, //Google recaptcha 요청 API
  KT_MVNO_VERIFY_API = 1030, // kt mvno확인
  VULNERABLE_VERIFY_API = 1028, // 취약계층 확인
}
